import figma from "./figma.png";
// import xd from "./xd.png";
// import html from "./html-5.png";
// import css from "./css-3.png";
import boot from "./bootstrap.png";
import js from "./js.png";
import vue from "./vue-logo.svg";
import react from "./react.png";
import tailwind from "./tailwind.png";
import reactRouter from "./react-router-v7.png"
import nodejs from "./nodejs.png";
import typescript from "./typescript.png";
import solana from "./solana.png";
import python from "./python.png"
import tanstackQuery from "./tanstack-query.png"
import axios from "./axios.png"

export const skills = [
    {
        name: "figma",
        img: figma,
        color: "#F24E1E",
    },
    // {
    //     name: "adobe xd",
    //     img: xd,
    //     color: "#FF61F6",
    // },
    // {
    //     name: "html",
    //     img: html,
    //     color: "#E34F26",
    // },
    // {
    //     name: "css",
    //     img: css,
    //     color: "#1572B6",
    // },
    {
        name: "bootstrap",
        img: boot,
        color: "#7952B3",
    },
    {
        name: "tailwind",
        img: tailwind,
        color: "#06B6D4",
    },
    {
        name: "javascript",
        img: js,
        color: "#F7DF1E",
    },
    {
        name: "vue",
        img: vue,
        color: "#42B883",
    },
    {
        name: "react",
        img: react,
        color: "#61DAFB",
    },
    {
        name: "react-router-v7",
        img: reactRouter,
        color: "#D0021B",
    },
    {
        name: "typescript",
        img: typescript,
        color: "#3178C6",
    },
    {
        name: "node",
        img: nodejs,
        color: "#339933",
    },
    {
        name: "python",
        img: python,
        color: "#377EF0",
    },
    {
        name: "solana",
        img: solana,
        color: "#6B92D0",
    },
    {
        name: "tanstack-query",
        img: tanstackQuery,
        color: "#FF9572",
    },
    {
        name: "axios",
        img: axios,
        color: "#671ddf",
    },
];
